import React from 'react'

interface FileExplorerErrorStateProps {
  error: Error
  onRetry: () => void
}

const FileExplorerErrorState: React.FC<FileExplorerErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="flex flex-col gap-4 p-4 text-gray-900 dark:text-white">
      <div className="text-red-400">
        <h2 className="text-xl font-semibold mb-2 text-red-600 dark:text-[#DD524C]">
          Error loading files
        </h2>
        <p>{error.message}</p>
        <button
          className="px-4 py-2 bg-blue-600 dark:bg-blue-700 rounded hover:bg-blue-700 dark:hover:bg-blue-800 mt-4 text-white"
          onClick={onRetry}
        >
          Try Again
        </button>
      </div>
    </div>
  )
}

export default FileExplorerErrorState
